import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');

$(function () {
    if (inBackend) return;

    $('.list-filter').each(function () {
        const $root = $(this);
        const $items = $root.find('.list-filter-item');
        const $checkboxes = $root.find('.filter-checkbox');
        const $ranges = $root.find('.filter-range');

        function updateRangeLabels() {
            $ranges.each(function () {
                const $range = $(this);
                const name = $range.data('filterName');
                const value = $range.val();
                const $label = $root.find('.filter-range-value[data-filter-label="' + name + '"]');

                if ($label.length) {
                    let unit = '';

                    if (name === 'max-spindle-stroke') {
                        unit = ' mm';
                    } else if (name === 'max-force') {
                        unit = ' kN';
                    } else if (name === 'workpiece-diameter') {
                        unit = ' mm';
                    }

                    $label.text(value + unit);
                }
            });
        }

        function collectFilters() {
            const filters = {};
            const ranges = {};

            $checkboxes.each(function () {
                const $cb = $(this);
                const name = $cb.data('filterName'); // z.B. "performance-level-selectable"
                const value = ($cb.val() || '').toString().trim();

                if (!$cb.is(':checked')) {
                    return;
                }

                if (!filters[name]) {
                    filters[name] = [];
                }
                filters[name].push(value);
            });

            $ranges.each(function () {
                const $range = $(this);
                const name = $range.data('filterName');
                const value = parseFloat($range.val());
                const maxAttr = parseFloat($range.attr('max'));

                if (isNaN(value)) {
                    return;
                }

                if (!isNaN(maxAttr) && value < maxAttr) {
                    ranges[name] = value;
                }
            });

            return { filters, ranges };
        }

        function itemMatchesFilters($item, filters, ranges) {
            let visible = true;

            Object.keys(filters).forEach(function (key) {
                if (!visible) return;

                const selectedValues = filters[key];
                if (!selectedValues.length) return;

                const raw = $item.attr('data-' + key);
                const itemValues = (raw || '')
                    .toString()
                    .split(',')
                    .map(value => value.trim())
                    .filter(Boolean);

                const hasMatch = selectedValues.some(value => itemValues.indexOf(value) !== -1);

                if (!itemValues.length || !hasMatch) {
                    visible = false;
                }
            });

            if (!visible) return false;

            const rangeKeys = ['max-spindle-stroke', 'max-force', 'workpiece-diameter'];

            rangeKeys.forEach(function (key) {
                if (!visible) return;

                if (ranges[key] === undefined) {
                    return;
                }

                const raw = $item.attr('data-' + key);
                if (!raw) {
                    visible = false;
                    return;
                }

                const itemVal = parseFloat(raw);
                if (isNaN(itemVal)) {
                    visible = false;
                    return;
                }

                const maxAllowed = ranges[key];
                if (itemVal > maxAllowed) {
                    visible = false;
                }
            });

            return visible;
        }

        function applyFilters() {
            const { filters, ranges } = collectFilters();

            const hasAnyCheckboxFilter = Object.keys(filters).some(
                key => filters[key] && filters[key].length
            );
            const hasAnyRangeFilter = Object.keys(ranges).length > 0;
            const hasAnyFilter = hasAnyCheckboxFilter || hasAnyRangeFilter;

            $items.each(function () {
                const $item = $(this);

                if (!hasAnyFilter) {
                    $item.show();
                    return;
                }

                const matches = itemMatchesFilters($item, filters, ranges);
                if (matches) {
                    $item.show();
                } else {
                    $item.hide();
                }
            });
        }

        $checkboxes.on('change', function () {
            applyFilters();
        });

        $ranges.on('input change', function () {
            updateRangeLabels();
            applyFilters();
        });

        updateRangeLabels();
        applyFilters();
    });
});
